import { MutationTree } from "vuex";
import { IDuplicateBookingsState } from "@/modules/DuplicateBookings/vuex/state";
import { DuplicateBookingRecord } from "@/modules/DuplicateBookings/interfaces/duplicateBookingsResponse.interface";
const mutations: MutationTree<IDuplicateBookingsState> = {
  setDuplicateBookingsLoading(state, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setDuplicateBookingsError(state, error: string | null) {
    state.error = error;
  },
  setDuplicateBookingsData(state, payload: DuplicateBookingRecord) {
    state.duplicateBookings = payload;
    state.error = null;
    state.isLoading = false;
  },
  resetDuplicateBookingsState(state) {
    state.duplicateBookings = null;
    state.error = null;
    state.isLoading = false;
  },
};

export default mutations;
